import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable({providedIn: 'root'})
export class PageTitleService {
    private _title$ = new BehaviorSubject<string | null>(null);
    readonly title$ = this._title$.asObservable();

    setTitle(title: string | null): void {
        // Defer emission to avoid NG0100 when called during a child component's
        // change detection (e.g. dashboard init) while the header has already been checked.
        Promise.resolve().then(() => this._title$.next(title));
    }
}
